import { useLayoutEffect, useRef, type RefObject } from "react";
import { syncEmailBuilderSettingsPanelScroll } from "./emailBuilderSettingsPanelScroll";

export function useEmailBuilderSettingsPanelScrollOnChange(
  elementRef: RefObject<HTMLElement | null>,
  value: unknown,
): void {
  const previousValueRef = useRef(value);

  useLayoutEffect(() => {
    const previousValue = previousValueRef.current;
    previousValueRef.current = value;

    if (previousValue === value || !elementRef.current) {
      return;
    }

    syncEmailBuilderSettingsPanelScroll(elementRef.current);
  }, [elementRef, value]);
}
